import _classCallCheck from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Param } from "../../core/context/Param";
import { ToneAudioNode } from "../../core/context/ToneAudioNode";
import { optionsFromArguments } from "../../core/util/Defaults";
import { readOnly } from "../../core/util/Interface";
/**
 * Compressor is a thin wrapper around the Web Audio
 * [DynamicsCompressorNode](http://webaudio.github.io/web-audio-api/#the-dynamicscompressornode-interface).
 * Compression reduces the volume of loud sounds or amplifies quiet sounds
 * by narrowing or "compressing" an audio signal's dynamic range.
 * Read more on [Wikipedia](https://en.wikipedia.org/wiki/Dynamic_range_compression).
 * @example
 * const comp = new Tone.Compressor(-30, 3);
 * @category Component
 */

export var Compressor = /*#__PURE__*/function (_ToneAudioNode) {
  _inherits(Compressor, _ToneAudioNode);

  var _super = _createSuper(Compressor);

  function Compressor() {
    var _this;

    _classCallCheck(this, Compressor);

    _this = _super.call(this, optionsFromArguments(Compressor.getDefaults(), arguments, ["threshold", "ratio"]));
    _this.name = "Compressor";
    /**
     * the compressor node
     */

    _this._compressor = _this.context.createDynamicsCompressor();
    _this.input = _this._compressor;
    _this.output = _this._compressor;
    var options = optionsFromArguments(Compressor.getDefaults(), arguments, ["threshold", "ratio"]);
    _this.threshold = new Param({
      minValue: _this._compressor.threshold.minValue,
      maxValue: _this._compressor.threshold.maxValue,
      context: _this.context,
      convert: false,
      param: _this._compressor.threshold,
      units: "decibels",
      value: options.threshold
    });
    _this.attack = new Param({
      minValue: _this._compressor.attack.minValue,
      maxValue: _this._compressor.attack.maxValue,
      context: _this.context,
      param: _this._compressor.attack,
      units: "time",
      value: options.attack
    });
    _this.release = new Param({
      minValue: _this._compressor.release.minValue,
      maxValue: _this._compressor.release.maxValue,
      context: _this.context,
      param: _this._compressor.release,
      units: "time",
      value: options.release
    });
    _this.knee = new Param({
      minValue: _this._compressor.knee.minValue,
      maxValue: _this._compressor.knee.maxValue,
      context: _this.context,
      convert: false,
      param: _this._compressor.knee,
      units: "decibels",
      value: options.knee
    });
    _this.ratio = new Param({
      minValue: _this._compressor.ratio.minValue,
      maxValue: _this._compressor.ratio.maxValue,
      context: _this.context,
      convert: false,
      param: _this._compressor.ratio,
      units: "positive",
      value: options.ratio
    }); // set the defaults

    readOnly(_assertThisInitialized(_this), ["knee", "release", "attack", "ratio", "threshold"]);
    return _this;
  }

  _createClass(Compressor, [{
    key: "reduction",
    get:
    /**
     * A read-only decibel value for metering purposes, representing the current amount of gain
     * reduction that the compressor is applying to the signal. If fed no signal the value will be 0 (no gain reduction).
     */
    function get() {
      return this._compressor.reduction;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      _get(_getPrototypeOf(Compressor.prototype), "dispose", this).call(this);

      this._compressor.disconnect();

      this.attack.dispose();
      this.release.dispose();
      this.threshold.dispose();
      this.ratio.dispose();
      this.knee.dispose();
      return this;
    }
  }], [{
    key: "getDefaults",
    value: function getDefaults() {
      return Object.assign(ToneAudioNode.getDefaults(), {
        attack: 0.003,
        knee: 30,
        ratio: 12,
        release: 0.25,
        threshold: -24
      });
    }
  }]);

  return Compressor;
}(ToneAudioNode);